/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/102-undo': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M8 1a7.979 7.979 0 00-5.657 2.343L0 1v6h6L3.757 4.757a6 6 0 118.211 8.743l1.323 1.5A8 8 0 008 1z"/>'
  }
})
